import { createAction, props } from '@ngrx/store';

import { AccordionId } from '../../reducers/terms-accordion/terms-accordion.reducer';

export const acceptAccordion = createAction(
  '[Terms Accordion] Accept Accordion',
  props<{ accordionId: AccordionId; acceptedAt: string }>(),
);

export const unacceptAccordion = createAction(
  '[Terms Accordion] Unaccept Accordion',
  props<{ accordionId: AccordionId }>(),
);

export const setExpandedAccordion = createAction(
  '[Terms Accordion] Set Expanded Accordion',
  props<{ accordionId: AccordionId | null }>(),
);

export const resetAccordionState = createAction('[Terms Accordion] Reset Accordion State');
